import ProfilePage from '@/modules/account/pages/Profile.vue';
import ContactsPage from '@/modules/account/pages/Contacts.vue';
import TeamsPage from '@/modules/account/pages/Teams.vue';
import TeamUsersPage from '@/modules/account/pages/teams/TeamUsers.vue';
import BillingPage from '@/modules/account/pages/Billing.vue';
import PlanPage from '@/modules/account/pages/billing/Plan.vue';
import SubscriptionPage from '@/modules/account/pages/Subscription.vue';
import DeveloperPage from '@/modules/account/pages/developer/DeveloperPage.vue';
import ManageApplications from '@/modules/account/pages/developer/ManageApplications.vue';
import DeveloperDocumentation from '@/modules/account/pages/developer/DeveloperDocumentation.vue';
import ConfigurationPage from '@/modules/account/pages/Configuration.vue';
import AccountLayout from '@/ui/layouts/Account.vue';
import UsersPage from '@/modules/account/pages/users/UsersPage.vue';
import PendingInvites from '@/modules/account/pages/users/PendingInvites.vue';
import UsersGuest from '@/modules/account/pages/users/UsersGuest.vue';
import IntegrationsPage from '@/modules/account/pages/integrations/IntegrationsPage.vue';
import IntegrationsAllTools from '@/modules/account/pages/integrations/IntegrationsAllTools.vue';
import ActiveIntegrations from '@/modules/account/pages/integrations/ActiveIntegrations.vue';
import ManageWebhooks from '@/modules/account/pages/developer/ManageWebhooks.vue';
import ManageWebhookEvents from '@/modules/account/pages/developer/ManageWebhookEvents.vue';
import BackupsPage from '@/modules/account/pages/backups/BackupsPage.vue';
import DetailsBackup from '@/modules/account/pages/backups/DetailsBackup.vue';
import ApiPermissions from '@/enums/ApiPermissions';

export default {
  name: 'people',
  routes: [
    {
      path: '/account',
      component: AccountLayout,
      redirect: {
        name: 'account.profile',
      },
      children: [
        {
          path: '/account/profile',
          name: 'account.profile',
          component: ProfilePage,
        },
        {
          path: '/account/contacts',
          name: 'account.contacts',
          component: ContactsPage,
        },
        {
          path: '/account/teams',
          name: 'account.teams',
          component: TeamsPage,
        },
        {
          path: '/account/teams/:teamId/users',
          name: 'account.teams.users',
          component: TeamUsersPage,
        },
        {
          path: '/account/billing',
          name: 'account.billing',
          component: BillingPage,
        },
        {
          path: '/account/billing/plan',
          name: 'account.billing.plan',
          component: PlanPage,
          meta: {
            requiresAdmin: true,
            permission: ApiPermissions.BILLING_VIEW,
          },
        },
        {
          path: '/account/billing/subscription/:planId/:organizationId',
          name: 'account.billing.subscription',
          component: SubscriptionPage,
        },
        {
          path: '/account/backup',
          name: 'account.backup',
          component: BackupsPage,
          meta: {
            requiresAdmin: true,
          },
        },
        {
          path: '/account/backup/details-backup/:uuid',
          name: 'account.backup.details-backup',
          component: DetailsBackup,
          meta: { requiresAdmin: true },
        },
        {
          path: '/account/developer',
          name: 'account.developer',
          component: DeveloperPage,
          meta: { requiresAdmin: true },
          redirect: { name: 'account.developer.manageapplications' },
          children: [
            {
              path: 'manageapplications',
              name: 'account.developer.manageapplications',
              component: ManageApplications,
            },
            {
              path: 'documentation',
              name: 'account.developer.documentation',
              component: DeveloperDocumentation,
            },
            {
              path: 'webhooks',
              name: 'account.developer.webhooks',
              component: ManageWebhooks,
            },
            {
              path: 'webhookevents/:webhookId',
              name: 'account.developer.webhookevents',
              component: ManageWebhookEvents,
            },
          ],
        },
        {
          path: '/account/configuration',
          name: 'account.configuration',
          component: ConfigurationPage,
          meta: { requiresAdmin: true },
        },
        {
          path: '/account/users/',
          name: 'account.users',
          component: UsersPage,
          redirect: { name: 'account.users.usersguest' },
          meta: { requiresAdmin: true },
          children: [
            {
              path: 'usersguest',
              name: 'account.users.usersguest',
              component: UsersGuest,
            },
            {
              path: 'pendinginvites',
              name: 'account.users.pendinginvites',
              component: PendingInvites,
            },
          ],
        },
        {
          path: '/account/integrations',
          name: 'account.integrations',
          component: IntegrationsPage,
          meta: { requiresAdmin: true },
          redirect: { name: 'account.integrations.alltools' },
          children: [
            {
              path: 'alltools',
              name: 'account.integrations.alltools',
              component: IntegrationsAllTools,
            },
            {
              path: 'activeintegrations',
              name: 'account.integrations.activeintegrations',
              component: ActiveIntegrations,
            },
          ],
        },
      ],
    },
  ],
};
